"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var usePostJSON_1 = __importDefault(require("../../../../hooks/usePostJSON"));
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var Button_1 = __importDefault(require("../../../Button/Button"));
var DateField_1 = __importDefault(require("../../../Form/fields/DateField"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var EditEndComps_1 = require("../EditEndComps");
var Utils_1 = require("../Utils");
var validation = function (values) {
    if (values != null)
        return;
    return;
};
var FormDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  form {\n    div:not(:only-child):first-child {\n      padding: 0;\n    }\n  }\n"], ["\n  form {\n    div:not(:only-child):first-child {\n      padding: 0;\n    }\n  }\n"])));
var ZanikOpravneniDialogForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var initialValues = _a.initialValues, onZrusit = _a.onZrusit, refetch = _a.refetch, znalecValues = _a.znalecValues, tlumocnikValues = _a.tlumocnikValues, isKancelar = _a.isKancelar;
    var _k = ConfigProvider_1.useConfig(), apiUrl = _k.apiUrl, typ = _k.typ;
    var iszrUrl = ConfigProvider_1.useConfig().iszrUrl;
    var postJSON = usePostJSON_1.default(apiUrl + "/Obnoveni");
    var zmenOsobu = usePostJSON_1.default(iszrUrl + "/ZmenOsobu");
    var token = hooks_1.useToken();
    var submitted = hooks_1.useBoolean(false);
    var uzivatel = 'Anonymous';
    if (((_b = token.getDataFromToken()) === null || _b === void 0 ? void 0 : _b.name) || ((_c = token.getDataFromToken()) === null || _c === void 0 ? void 0 : _c.surname)) {
        uzivatel = ((_d = token.getDataFromToken()) === null || _d === void 0 ? void 0 : _d.name) + " " + ((_e = token.getDataFromToken()) === null || _e === void 0 ? void 0 : _e.surname);
    }
    var onSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var obnoveniValues, response, jinyZanik, zanikAPreruseni, zmenOsobuValues, zanikyError, rosResponseV1, rosResponse, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 13, 14, 15]);
                    formikHelpers.setStatus(undefined);
                    obnoveniValues = {
                        idZnalec: typ === 'znalec' ? values.idZnalec : undefined,
                        idTlumocnik: typ === 'tlumocnik' ? values.idTlumocnik : undefined,
                        datumOpakovanehoZapisu: values.do,
                    };
                    return [4 /*yield*/, postJSON(obnoveniValues)];
                case 1:
                    response = _c.sent();
                    if (!either_1.isRight(response)) return [3 /*break*/, 11];
                    if (!refetch) return [3 /*break*/, 3];
                    return [4 /*yield*/, refetch()];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    submitted.setTrue();
                    if (!!isKancelar) return [3 /*break*/, 10];
                    jinyZanik = response.value;
                    zanikAPreruseni = {
                        datumVznikuOpravneni: (_a = jinyZanik.datumZapisu) === null || _a === void 0 ? void 0 : _a.substring(0, 10),
                        datumZanikuOpravneni: (_b = jinyZanik.datumOd) === null || _b === void 0 ? void 0 : _b.substring(0, 10),
                        pozastaveniOpravneniBool: jinyZanik.aktivniPozastaveni,
                        datumZanikuPlatnost: jinyZanik.neplatnyZanik ? false : undefined,
                        uzivatel: uzivatel,
                    };
                    zmenOsobuValues = void 0;
                    // znalec
                    if (znalecValues) {
                        zmenOsobuValues = Utils_1.znalecValuesForROS(znalecValues, zanikAPreruseni);
                    }
                    zanikyError = void 0;
                    if (!tlumocnikValues) return [3 /*break*/, 6];
                    zmenOsobuValues = Utils_1.tlumocnikValuesForROS(tlumocnikValues, zanikAPreruseni);
                    if (!(zmenOsobuValues.DatumVznikuOpravneni && zmenOsobuValues.DatumZanikuOpravneni && zmenOsobuValues.DatumVznikuOpravneni > zmenOsobuValues.DatumZanikuOpravneni)) return [3 /*break*/, 6];
                    if (!!jinyZanik.jedenSubjekt) return [3 /*break*/, 5];
                    return [4 /*yield*/, zmenOsobu(__assign(__assign({}, zmenOsobuValues), { DatumVznikuOpravneni: undefined }))];
                case 4:
                    rosResponseV1 = _c.sent();
                    if (!either_1.isRight(rosResponseV1))
                        zanikyError = rosResponseV1.value.message;
                    _c.label = 5;
                case 5:
                    zmenOsobuValues = __assign(__assign({}, zmenOsobuValues), { DatumZanikuOpravneni: undefined });
                    _c.label = 6;
                case 6:
                    if (!(zmenOsobuValues.DatumVznikuOpravneni || zmenOsobuValues.DatumZanikuOpravneni)) return [3 /*break*/, 9];
                    return [4 /*yield*/, zmenOsobu(zmenOsobuValues)];
                case 7:
                    rosResponse = _c.sent();
                    formikHelpers.setSubmitting(false);
                    if (!zanikyError && either_1.isRight(rosResponse))
                        formikHelpers.setStatus({ message: 'Referenční údaje byly úspěšně aktualizovány v ROS.', type: 'success' });
                    else
                        formikHelpers.setStatus({ message: zanikyError !== null && zanikyError !== void 0 ? zanikyError : rosResponse.value.message, type: 'error' });
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
                case 8:
                    _c.sent();
                    return [3 /*break*/, 10];
                case 9:
                    formikHelpers.setSubmitting(false);
                    _c.label = 10;
                case 10:
                    onZrusit();
                    return [3 /*break*/, 12];
                case 11:
                    formikHelpers.setStatus({ message: response.value.message, type: 'error' });
                    _c.label = 12;
                case 12: return [3 /*break*/, 15];
                case 13:
                    e_1 = _c.sent();
                    console.error(e_1);
                    formikHelpers.setStatus({ message: 'Během úpravy zániku oprávnění nastala chyba.', type: 'error' });
                    return [3 /*break*/, 15];
                case 14:
                    formikHelpers.setSubmitting(false);
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var minDate;
    if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.od) {
        minDate = new Date(dayjs_1.default(initialValues.od).add(1, 'day').toISOString());
        var maxZanikOd = void 0;
        if (znalecValues) {
            maxZanikOd = (_g = (_f = znalecValues.preruseniCinnosti) === null || _f === void 0 ? void 0 : _f.zanikOpravneni[0]) === null || _g === void 0 ? void 0 : _g.datumOd;
        }
        if (tlumocnikValues) {
            maxZanikOd = (_j = (((_h = tlumocnikValues.preruseniCinnosti) === null || _h === void 0 ? void 0 : _h.zanikOpravneni) || [])[0]) === null || _j === void 0 ? void 0 : _j.datumOd;
        }
        if (maxZanikOd) {
            maxZanikOd = new Date(maxZanikOd);
            maxZanikOd.setDate(maxZanikOd.getDate() + 1);
            if (maxZanikOd > minDate)
                minDate = maxZanikOd;
        }
    }
    return (react_1.default.createElement(FormDiv, null,
        react_1.default.createElement(Form_1.default, { initialValues: initialValues || {}, validate: validation, onSubmit: onSubmit }, function (_a) {
            var isSubmitting = _a.isSubmitting;
            return (react_1.default.createElement(EditEndComps_1.EditEndDialog, null,
                react_1.default.createElement(EditEndComps_1.EditEndDialogText, null, "Zapsat opr\u00E1vn\u011Bn\u00ED"),
                react_1.default.createElement(DateField_1.default, { label: "Datum z\u00E1pisu opr\u00E1vn\u011Bn\u00ED:", name: "do", minDate: minDate, toolTip: "Vyberte datum z\u00E1pisu opr\u00E1vn\u011Bn\u00ED", readOnly: submitted.value }),
                (!submitted.value || isSubmitting) && (react_1.default.createElement(EditEndComps_1.EditEndButtonsWrap, null,
                    react_1.default.createElement(Button_1.default, { type: "button", primary: false, loading: isSubmitting, onClick: onZrusit, name: "Zrusit", disabled: submitted.value }, "ZRU\u0160IT"),
                    react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Ulozit", disabled: submitted.value }, "ZAPSAT OPR\u00C1V\u011AN\u00CD")))));
        })));
};
ZanikOpravneniDialogForm.defaultProps = {
    initialValues: undefined,
    refetch: undefined,
    znalecValues: undefined,
    tlumocnikValues: undefined,
    isKancelar: undefined,
};
exports.default = ZanikOpravneniDialogForm;
var templateObject_1;
